import { render, staticRenderFns } from "./AgreementKoseIdProductRegistrationModal.vue?vue&type=template&id=316edb44&scoped=true&lang=pug&"
import script from "./AgreementKoseIdProductRegistrationModal.vue?vue&type=script&lang=ts&"
export * from "./AgreementKoseIdProductRegistrationModal.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementKoseIdProductRegistrationModal.vue?vue&type=style&index=0&id=316edb44&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316edb44",
  null
  
)

export default component.exports